import { Component, computed, signal } from '@angular/core';

// EZ
import { DocMeta } from '@template-ui/decorators';
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { ButtonConfig, EzFormInputType, InputConfig, PanelHeaderConfig } from '@template-ui/types';

@DocMeta({
  hide: true,
  showcaseTitle: 'Nested Panels',
  showcaseDesc: 'Reproduces nested panel shadow behavior with three panel levels and a conditional header button.',
  showcaseAttachTo: [{ libName: 'Base Library', classNames: ['EzPanelComponent'] }],
})
@Component({
  selector: 'ui-nested-panels-sample, ez-nested-panels-sample',
  imports: [UiLibraryModule],
  templateUrl: './nested-panels-sample.component.html',
  styleUrl: './nested-panels-sample.component.scss',
})
export class NestedPanelsSampleComponent {
  protected readonly sampleControls = signal<{ showHeaderButton?: boolean; allPanelsToggleable?: boolean }>({
    showHeaderButton: true,
    allPanelsToggleable: false,
  });
  protected readonly sampleFormValues = signal<{ mode?: string; modeDetail?: string }>({});

  protected readonly controlsConfig: InputConfig[] = [
    {
      type: EzFormInputType.CHECKBOX,
      name: 'allPanelsToggleable',
      label: 'All nested panels are toggleable',
      width: '2x',
    },
    {
      type: EzFormInputType.CHECKBOX,
      name: 'showHeaderButton',
      label: 'Show inner header button',
      width: '2x',
      row: 2,
    },
  ];

  protected readonly innerFormConfig: InputConfig[] = [
    {
      type: EzFormInputType.RADIO_GROUP,
      name: 'mode',
      label: 'Decision Review',
      width: '2x',
      options: [
        { viewValue: 'Mode A', value: 'A' },
        { viewValue: 'Mode B', value: 'B' },
      ],
      customCssClasses: 'vertical',
    },
    {
      type: EzFormInputType.TEXTAREA,
      name: 'modeDetail',
      label: 'Mode B Detail',
      width: '4x',
      row: 2,
      textAreaRows: 3,
      maxLength: 4000,
      showCharactersLeft: true,
      show: computed(() => this.sampleFormValues().mode === 'B'),
    },
  ];

  protected readonly innerPanelHeaderConfig = computed<PanelHeaderConfig>(() => ({
    panelHeaderTitle: 'Inner Panel (Level 3)',
    additionalActions: this.sampleControls().showHeaderButton
      ? { buttonsConfig: [{ id: 'inner-action', buttonText: 'Panel', disabled: true } as ButtonConfig] }
      : undefined,
  }));
}
